module.exports = __webpack_public_path__ + "img/n2.fc4a4e14.jpg";